module.exports = __webpack_public_path__ + "img/schwein-frei@2x.da75f45b.png";